import { IClassname } from '@/lib/shared/model/classname';

export const CCTV = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7230)">
        <path
          d="M20.4726 10.8886C20.4726 11.058 20.4053 11.2206 20.2855 11.3404C20.1656 11.4602 20.0031 11.5275 19.8337 11.5275H7.05449C6.88502 11.5275 6.7225 11.4602 6.60267 11.3404C6.48285 11.2206 6.41553 11.058 6.41553 10.8886V4.49899C6.41553 3.65168 6.75212 2.83907 7.35126 2.23993C7.9504 1.64079 8.76301 1.3042 9.61032 1.3042H30.057C30.154 1.30423 30.2498 1.32636 30.337 1.36893C30.4243 1.4115 30.5006 1.47337 30.5604 1.54987C30.6201 1.62636 30.6617 1.71545 30.6818 1.81039C30.702 1.90533 30.7003 2.00361 30.6768 2.09779L29.6877 6.05933C29.6603 6.16864 29.6045 6.26877 29.526 6.34957C29.4474 6.43036 29.3489 6.48894 29.2404 6.51938L20.4726 8.9717V10.8886Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5844 7.54004V13.444C25.5844 13.6135 25.5171 13.776 25.3973 13.8958C25.2775 14.0157 25.1149 14.083 24.9455 14.083H10.2494C9.57159 14.083 8.9215 13.8137 8.44219 13.3344C7.96288 12.8551 7.6936 12.205 7.6936 11.5271"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.1401 9.61035V12.1662"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5273 16.6392H16.639"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0831 16.6392V23.2588C14.0835 23.5536 13.9819 23.8395 13.7956 24.0679C13.6092 24.2964 13.3497 24.4534 13.0608 24.5124L1.30396 26.8625"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 23.0283V30.6958"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7230">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
